import { PRODUCT_LECTURA } from '../../../lib/constants';
import { GRADES } from '../../hub/data/constants';
import troTruthTable from '../data/tro_mtg_truth_table.json';

export const calculateScore = (result, scoring) => {
  const scores = Object.keys(scoring);
  let finalScore = 'green';

  scores.forEach((score) => {
    const bracket = scoring[score];
    if (Array.isArray(bracket)) {
      if (result >= bracket[0] && result <= bracket[1]) {
        finalScore = score;
      }
    } else if (result >= bracket) {
      finalScore = score;
    }
  });

  return finalScore;
};

const sumTotalScores = arr => arr.map(({ total_score }) => total_score).reduce((total, score) => total + score);

export const calculatePlacement = (results, placements, troData, toy, studentGrade, product) => {
  const gradeKey = `${studentGrade}`;
  let resultScore;

  // for TRO placement calculation, clamp student grade to [1, 5]
  const grade = Math.min(Math.max(parseInt(gradeKey, 10), 1), 5);

  if (troData.is_complete) {
    const resultsObject = troTruthTable[troData.benchmark_status][`${grade}${toy}`];
    const mtgTotalScore = results.length ? results[0].total_score : 0;

    const [lowBracket, highBracket] = Object.keys(resultsObject);
    const brackets = [lowBracket.split('-'), highBracket.replace('+', '')];
    if (brackets[0][0] <= mtgTotalScore && brackets[0][1] >= mtgTotalScore) {
      resultScore = resultsObject[lowBracket];
    } else if (mtgTotalScore >= brackets[1]) {
      resultScore = resultsObject[highBracket];
    }
  } else if (product === PRODUCT_LECTURA) {
    // UPDATE starting with SY24-25: For Lectura APT, we are not calculating Mind the Gap score
    // or Phonological Awareness score (sum of blending, segmenting measure), but are still serving submeasures.
    // Only calculate Decoding score (sum of letter sound correspondences, syllable decoding, real word reading).
    const decodingScoring = {
      [GRADES.KINDERGARTEN]: {
        green: [0, 22],
        blue: 23,
      },
      [GRADES.GRADE_1]: {
        red: [0, 10],
        green: [11, 16],
        blue: 17,
      },
      [GRADES.GRADE_2]: {
        green: [0, 24],
        blue: 25,
      },
      [GRADES.GRADE_3]: {
        green: [0, 24],
        blue: 25,
      },
    };

    // only take Decoding measures from curriculum json
    const decodingResults = [GRADES.GRADE_2, GRADES.GRADE_3].includes(gradeKey)
      ? sumTotalScores(results.slice(0, 1))
      : sumTotalScores(results.slice(2, 5));

    // calculate final placement score corresponding to color - red, green or blue
    const score = calculateScore(decodingResults, decodingScoring[gradeKey]);
    resultScore = placements[score];
  } else {
    const scores = results.map(({ score }) => score).join('_');
    resultScore = placements[scores];
  }
  return resultScore;
};
